import moment from 'moment';
import Mustache from '@rover/globals/Mustache';
import Rover from '@rover/globals/Rover';
// WARNING: DF from datetimeInjected is not SSR compatible.
// For newer code, use const DF = getDateTimeFormatMapForLang(<lang>) from '@rover/shared/js/constants/i18n/datetime'
import DF from '@rover/shared/js/constants/i18n/datetime/datetimeInjected';
import RequestableSummaryView from './requestable_summary_view';

export default RequestableSummaryView.extend({
  template: Mustache.template('new_design/account_conversations/recurring_billing'),
  priceField: 'totalPrice',
  getContextData() {
    const data = RequestableSummaryView.prototype.getContextData.apply(this);
    data.daysList = this.model.daysList().join(', ');
    data.start_date_formatted = moment(this.model.get('start_date')).format(DF.DATE_WEEK_SHORT);
    data.numUnitsPerDay = this.model.getPerDaySummary();
    return data;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/recurring_billing_summary_view.js